(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["creative-typography"] && !Shopify.designMode) return;
  try {
    
  if(typeof LunaWords !== 'function') {
    class LunaWords extends HTMLElement {
      constructor() {
        super()

        this.init()
        document.addEventListener("shopify:section:load", (event) => {
          this.init();
        });
      }
      init() {
        this.idx = 0
        this.template = this.querySelector('template').content.cloneNode(true)
        const div = document.createElement('div')
        div.className = 'lt-creative_typography-title'
        div.innerHTML = this.processContent(this.template.querySelector('.luna-templates_html').innerHTML);
        div.append(...this.template.querySelector('.luna-templates_blocks').childNodes);

        this.querySelector('.lt-creative_typography-title')?.remove()
        this.append(div)
      }
      processContent(html) {
        return html.replace(/(<[^>]+>.*?<\/[^>]+>)|(\S+)/g, (match, tag) => {
          this.idx += 1
          if(tag) {
            const newtag = tag.replace(/<([a-zA-Z0-9]+)([^>]*?)>(.*?)<\/\1>/g, (_, inner_tag, attrs, content) => content.split(' ').map((word, i) => {
              if(i != 0) this.idx += 1
              const c = `<span class="lt-creative_typography-word" style="order: ${ this.idx }"><${inner_tag}${attrs}>${word}</${inner_tag}></span>`

              return c
            }).join(' '));
            return newtag
          } else {
            return `<span class="lt-creative_typography-word" style="order: ${ this.idx }">${ match }</span>`
          }
        });
      }
    }

    customElements.define('luna-words', LunaWords)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
